<div class="sw-cms-el-config-moorl-toc">
    <mt-banner variant="info">
        {{ $tc('sw-cms.elements.moorl-toc.description') }}
    </mt-banner>
    <sw-cms-mapping-field
        v-model:config="element.config.content"
        value-types="string"
    >
        <sw-code-editor
            :label="$tc('sw-cms.elements.moorl-toc.label.content')"
            :softWraps="false"
            v-model:value="element.config.content.value"
        />
    </sw-cms-mapping-field>
</div>